import { motion } from 'framer-motion';
import {
  Award,
  Building2,
  Clock,
  Eye,
  GraduationCap,
  Network,
  PartyPopper,
  Shield,
  UserCheck,
} from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const CARDS = [
  {
    icon: UserCheck,
    title: 'Selección',
    text: 'Reclutamiento riguroso con verificación de antecedentes y evaluación psicológica.',
  },
  {
    icon: GraduationCap,
    title: 'Capacitación',
    text: 'Formación continua en defensa, primeros auxilios y protocolos de emergencia.',
  },
  {
    icon: Eye,
    title: 'Supervisión',
    text: 'Control operativo permanente con rondas, reportes y auditoría de turnos.',
  },
];

const TILES = [
  { icon: Shield, label: 'Protección Física' },
  { icon: Building2, label: 'Seguridad Corporativa' },
  { icon: PartyPopper, label: 'Eventos' },
  { icon: Clock, label: 'Turnos 24h' },
  { icon: Award, label: 'Personal de Élite' },
  { icon: Network, label: 'Coordinación' },
];

export function Services() {
  return (
    <Section id="services">
      <SectionTitle
        kicker="Servicio Principal"
        subtitle="Personal capacitado y supervisado para proteger lo que más te importa."
      >
        Guardias de seguridad privada
      </SectionTitle>
      <div className="grid gap-6 md:grid-cols-3">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              whileHover={{ y: -4 }}
              className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 transition-colors hover:border-primary/40 hover:bg-white/[0.04]"
            >
              <Icon className="h-9 w-9 text-primary" strokeWidth={1.5} aria-hidden />
              <h3 className="mt-4 text-lg font-semibold">{card.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{card.text}</p>
            </motion.div>
          );
        })}
      </div>
      <ul className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3">
        {TILES.map((tile) => {
          const Icon = tile.icon;
          return (
            <li
              key={tile.label}
              className="flex items-center gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] px-4 py-3 text-sm text-slate-300 transition-colors hover:bg-white/[0.04]"
            >
              <Icon className="h-5 w-5 shrink-0 text-primary" strokeWidth={1.5} aria-hidden />
              {tile.label}
            </li>
          );
        })}
      </ul>
    </Section>
  );
}
